import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { UserPreferencesState, WorkflowJobPreference, WorkflowTreeView, Dictionary, TableSortModel, TableFilterModel, ColumnConfiguration, SearchSplitConfiguration, PagesStoreMode } from '@/types';
import { defaultMtableState } from '../mtable';
import { TableSortPropertiesPreference } from '@/types/store/userPreferences/TableSortPropertiesPreference';

export function defaultverticalSider() {
  return { verticalTabWidth: 15, screenWidth: 0 };
}

export function defaultWorkflowJobPreference(
  queueId: any = 0,
  verticalSider: any = null,
  canGetNextJob: any = true,
  tableOptions: any = null,
  pinFilter: boolean = false,
  isHorizontalTabUp: boolean = false
) {
  return {
    queueId,
    verticalSider: verticalSider || defaultverticalSider(),
    canGetNextJob: canGetNextJob || true,
    tableOptions: tableOptions || defaultMtableState(),
    pinFilter,
    isHorizontalTabUp
  } as WorkflowJobPreference;
}

export function defaultUserPreferencesState() {
  return [
    {
      userId: 0,
      workflowJob: {
        workflowJobPreferences: [defaultWorkflowJobPreference()],
        SelectedWorkflowQueueID: 0
      },
      workflowTreeView: { verticalTabWidth: 20, screenWidth: 0 } as WorkflowTreeView,
      documentToStore: {
        targetDocumentTypes: {} as Dictionary<number>,
        documentTypeSelections: {} as Dictionary<Dictionary<number>>,
        tableFilters: {
          includeBatchNumber: false,
          pinFilter: false,
          searchTerm: '',
          showMultiSelect: false
        },
        canGetNextDocument: false,
        allPages: false,
        pagesStoreMode: PagesStoreMode.ManualPageSelection
      },
      suppressedConfirmations: [],
      documentsToStore: {
        documentsToStorePreference: [],
        tableSortPropertiesPreference: {
          sortBy: 'storedTime',
          sortDesc: true
        } as TableSortPropertiesPreference
      },
      workflowQueue: {
        sortOptions: {} as Dictionary<TableSortModel[]>,
        pinSort: {} as Dictionary<boolean>,
        filterOptions: {} as Dictionary<TableFilterModel[]>,
        columnConfigurations: {} as Dictionary<ColumnConfiguration[]>,
        retainFilterOptions: {} as Dictionary<boolean>
      },
      emailToMe: {
        dontAskAgain: false,
        convertToPdf: false
      },
      search: {
        cabinets: [],
        documentTypes: [],
        includeDocumentContent: null,
        pinSort: false,
        pinFilter: false,
        splitConfiguration: SearchSplitConfiguration.Vertical
      }
    }
  ] as UserPreferencesState[];
}

const namespaced: boolean = true;

export const state: UserPreferencesState[] = [] as UserPreferencesState[];

export const userPreferences = {
  namespaced,
  state,
  actions,
  getters,
  mutations,
  defaultUserPreferencesState,
  defaultWorkflowJobPreference
};
